export const COOKIE_MAX_AGE_1_YEAR = 365 * 24 * 60 * 60
export const CODE_DELIMETER = '^@`'
export const DOWNLOAD_URL = '/api/v2/files/nstc/'
